// extracted by mini-css-extract-plugin
export default {"page":"Page-module--page--24e03","page__inner":"Page-module--page__inner--8a961","page__title":"Page-module--page__title--5d268","page__body":"Page-module--page__body--2ab2f"};